import { Component, Input } from '@angular/core';
import { User } from '../../../models/User';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-child-added-modale',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './child-added-modale.component.html',
    styleUrl: './child-added-modale.component.scss',
})
export class ChildAddedModaleComponent {
    @Input() public user: User;

    constructor(private activeModale: NgbActiveModal) {}

    validate() {
        this.activeModale.close({ message: 'cancel' });
    }
}
